import React, { useState } from "react";
import bgImage from "../assets/login.jpg"; // Asegúrate de la ruta correcta

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin();
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen relative"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay oscuro */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Formulario */}
      <div className="relative z-10 w-full max-w-sm p-6 bg-white/90 dark:bg-slate-800/90 rounded-xl shadow-lg backdrop-blur-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-slate-800 dark:text-white">E-commerce Admin</h1>
        </div>

        <h1 className="text-2xl font-bold text-slate-800 dark:text-white mb-2">Iniciar Sesión</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
          Accede a tu panel de administración.
        </p>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
              Nombre de Usuario o Correo Electrónico
            </label>
            <div className="relative">
              <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">person</span>
              <input
                id="email"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Tu usuario o email"
                className="form-input block w-full rounded-md border-slate-300 dark:border-slate-600 bg-slate-50 dark:bg-slate-700 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 pl-10 py-3 focus:border-[#1173d4] focus:ring-[#1173d4] h-12"
              />
            </div>
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
              Contraseña
            </label>
            <div className="relative">
              <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">lock</span>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contraseña"
                className="form-input block w-full rounded-md border-slate-300 dark:border-slate-600 bg-slate-50 dark:bg-slate-700 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 pl-10 py-3 focus:border-[#1173d4] focus:ring-[#1173d4] h-12"
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <button type="button" className="text-sm font-medium text-[#1173d4] hover:text-[#1173d4]/80">
              Olvidé mi Contraseña
            </button>
          </div>

          <div>
            <button
              type="submit"
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-white bg-[#1173d4] hover:bg-[#1173d4]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1173d4] focus:ring-offset-slate-50 dark:focus:ring-offset-slate-900"
            >
              Iniciar Sesión
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
